export const CRM_ONLY_MODE = true;

export const CRM_DEFAULT_ROUTE = '/service-maintenance/dispatch/dispatch';

const TECHNICIAN_CRM_ROLES = ['tehnician', 'senior_tehnician'];
const NON_FULL_ACCESS_ROLES = new Set(['admin', 'tehnician', 'senior_tehnician', 'technician']);

const SHARED_ROUTES = new Set(['/home', '/logout', '/notifications']);
const ERP_EXACT_ROUTES = new Set(['/panel/erp']);

const ADMIN_ONLY_EXACT_ROUTES = new Set(['/panel/user']);
const ADMIN_ONLY_PREFIXES = ['/administration/user/'];

const FULL_CRM_EXACT_ROUTES = new Set([
  '/panel/company',
  '/panel/workPlace',
  '/panel/provider',
  '/panel/providerWorkPlace',
  '/panel/agent',
  '/panel/systemType',
  '/panel/deviceType',
  '/panel/infoDevice',
  '/panel/product',
  '/panel/erp',
  '/panel/labor',
  '/panel/laborExtra',
  '/service-maintenance/dispatch/dispatch',
  '/service-maintenance/dispatch/maintenancePlanning',
  '/service-maintenance/dispatch/myMaintenancePlannings',
  '/service-maintenance/interventionFiles',
  '/service-maintenance/interventionFile/supplies',
  '/service-maintenance/interventionFile/recommendations',
  '/service-maintenance/contract/active-contracts',
  '/service-maintenance/offer/active-offers',
]);

const FULL_CRM_PREFIX_ROUTES = [
  '/panel/company/',
  '/administration/workPlace/',
  '/administration/providerWorkPlace/',
  '/service-maintenance/dispatch/',
  '/service-maintenance/interventionFile/',
  '/service-maintenance/contract/',
  '/service-maintenance/offer/',
];

const LIMITED_CRM_EXACT_ROUTES = new Set([
  '/service-maintenance/dispatch/dispatch',
  '/service-maintenance/dispatch/myMaintenancePlannings',
  '/service-maintenance/interventionFiles',
]);

const LIMITED_CRM_PREFIX_ROUTES = [
  '/service-maintenance/dispatch/dispatch',
  '/service-maintenance/dispatch/new',
  '/service-maintenance/dispatch/edit',
  '/service-maintenance/dispatch/view',
  '/service-maintenance/interventionFile/',
];

const routeToMenuKeyMap: Array<{ prefix: string; menuKey: string }> = [
  { prefix: '/administration/user/', menuKey: '/panel/user' },
  { prefix: '/panel/company/', menuKey: '/panel/company' },
  { prefix: '/panel/erp', menuKey: '/panel/erp' },
  { prefix: '/administration/workPlace/', menuKey: '/panel/workPlace' },
  { prefix: '/administration/providerWorkPlace/', menuKey: '/panel/providerWorkPlace' },
  { prefix: '/service-maintenance/dispatch/dispatch', menuKey: '/service-maintenance/dispatch/dispatch' },
  { prefix: '/service-maintenance/dispatch/new', menuKey: '/service-maintenance/dispatch/dispatch' },
  { prefix: '/service-maintenance/dispatch/edit', menuKey: '/service-maintenance/dispatch/dispatch' },
  { prefix: '/service-maintenance/dispatch/view', menuKey: '/service-maintenance/dispatch/dispatch' },
  {
    prefix: '/service-maintenance/dispatch/maintenancePlanning',
    menuKey: '/service-maintenance/dispatch/maintenancePlanning',
  },
  {
    prefix: '/service-maintenance/dispatch/myMaintenancePlannings',
    menuKey: '/service-maintenance/dispatch/myMaintenancePlannings',
  },
  { prefix: '/service-maintenance/interventionFiles', menuKey: '/service-maintenance/interventionFiles' },
  { prefix: '/service-maintenance/interventionFile/new', menuKey: '/service-maintenance/interventionFiles' },
  { prefix: '/service-maintenance/interventionFile/edit', menuKey: '/service-maintenance/interventionFiles' },
  {
    prefix: '/service-maintenance/interventionFile/supplies',
    menuKey: '/service-maintenance/interventionFile/supplies',
  },
  {
    prefix: '/service-maintenance/interventionFile/recommendations',
    menuKey: '/service-maintenance/interventionFile/recommendations',
  },
  {
    prefix: '/service-maintenance/contract/',
    menuKey: '/service-maintenance/contract/active-contracts',
  },
  {
    prefix: '/service-maintenance/offer/',
    menuKey: '/service-maintenance/offer/active-offers',
  },
];

const hasAnyRole = (roles: string[] = [], allowedRoles: string[]) => {
  return roles.some((role) => allowedRoles.includes(role));
};

export const isAdminCrmRole = (roles: string[] = []) => {
  return roles.includes('admin');
};

export const hasFullCrmAccess = (roles: string[] = []) => {
  return isAdminCrmRole(roles) || roles.some((role) => !NON_FULL_ACCESS_ROLES.has(role));
};

export const hasLimitedCrmAccess = (roles: string[] = []) => {
  return hasAnyRole(roles, TECHNICIAN_CRM_ROLES);
};

export const canAccessUsersMenu = (roles: string[] = []) => {
  return isAdminCrmRole(roles);
};

export const isCrmAllowedRoute = (pathname: string, roles: string[] = []) => {
  if (SHARED_ROUTES.has(pathname)) {
    return true;
  }

  if (ERP_EXACT_ROUTES.has(pathname)) {
    return roles.includes('admin') || roles.includes('accountant');
  }

  if (isAdminCrmRole(roles)) {
    return (
      ADMIN_ONLY_EXACT_ROUTES.has(pathname) ||
      FULL_CRM_EXACT_ROUTES.has(pathname) ||
      ADMIN_ONLY_PREFIXES.some((prefix) => pathname.startsWith(prefix)) ||
      FULL_CRM_PREFIX_ROUTES.some((prefix) => pathname.startsWith(prefix))
    );
  }

  if (hasFullCrmAccess(roles)) {
    return FULL_CRM_EXACT_ROUTES.has(pathname) || FULL_CRM_PREFIX_ROUTES.some((prefix) => pathname.startsWith(prefix));
  }

  if (hasLimitedCrmAccess(roles)) {
    return (
      LIMITED_CRM_EXACT_ROUTES.has(pathname) || LIMITED_CRM_PREFIX_ROUTES.some((prefix) => pathname.startsWith(prefix))
    );
  }

  return pathname === CRM_DEFAULT_ROUTE;
};

export const getCrmSelectedMenuKey = (pathname: string) => {
  const match = routeToMenuKeyMap.find((item) => pathname.startsWith(item.prefix));

  if (match) {
    return match.menuKey;
  }

  return pathname;
};
